<ion-content>
  <app-task-details-item [task]="task"></app-task-details-item>
  <app-task-engagement-button [task]="task"></app-task-engagement-button>
  <app-task-attachments-button [task]="task"></app-task-attachments-button>
  <app-task-add-attachment-button [task]="task"></app-task-add-attachment-button>
  <app-task-journal-button [task]="task"></app-task-journal-button>
</ion-content>
